import React, { useEffect, useState } from "react";
import client from "../../lib/api";

export function DutyStrip() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => client.get("/duty/status").then(({ data }) => setD(data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const on = d.partners.filter((p) => p.on_duty).length;
  return (
    <div className="surface p-3 mb-5" data-testid="wf-duty-strip">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-[10px] uppercase tracking-widest text-slate-500 mr-1">Duty</span>
        <span className={`text-xs font-semibold ${on ? "text-bull" : "text-bear"}`} data-testid="wf-duty-count">{on}/{d.partners.length} ON</span>
        {d.partners.map((p) => (
          <span key={p.id} className="text-[11px] px-2 py-0.5 border border-[color:var(--border-subtle)] text-slate-300 flex items-center gap-1.5" data-testid={`wf-duty-${p.id}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${p.on_duty ? "bg-[#22c55e]" : "bg-slate-600"}`} />{p.name}{p.leads_paused && <span className="text-bear">· paused</span>}
          </span>
        ))}
        {d.unassigned > 0 && <a href="/partners" className="ml-auto text-xs text-gold hover:underline" data-testid="wf-unassigned-link">{d.unassigned} unassigned leads — assign karein →</a>}
      </div>
      {!on && d.partners.length > 0 && <p className="text-[11px] text-bear mt-2">Sab partners OFF hain — nayi leads aapke paas aa rahi hain (Telegram buttons ya Team Partners page se assign karein).</p>}
    </div>
  );
}
